module.exports = __webpack_public_path__ + "img/2right-n-12a97aef.png";